<template>
    <div class="wrapper">
        <div class="top">
            <div class="tabs">
                <div
                        class="tab"
                        v-for="(item,index) in orderTypes"
                        :key="index"
                        @click="changeOrderType(index)"
                        :class="{'active':statusIndex==index}"
                >{{item}}
                </div>
            </div>

        </div>
        <div class="order-wrap">
            <div class="order-head order-box">
                <div class="order-info">商品</div>
                <div class="order-price">已付金额</div>
                <div class="order-num"></div>
                <div class="order-total-price">总价</div>
                <div class="order-state">订单状态</div>
                <div class="order-handle">操作</div>
            </div>
            <div v-if="orderList.length==0" class="no-order">
                <div v-show="statusIndex>0">没有{{orderTypes[statusIndex]}}的订单哟~</div>
                <div v-show="statusIndex==0">没有定制订单信息，快去下单吧~</div>
            </div>
            <div v-show="orderList.length>0">
                <div class="order-item" v-for="(order,index) in orderList" :key="index">
                    <div class="order-item-head">
                        <span class="time">{{orderTime(order.ctime)}}</span>
                        订单号：
                        <span class="code">{{order.order_id}}</span>
                    </div>
                    <div class="order-item-main order-box">
                        <div class="order-info-list">
                            <div class="order-li">
                                <div class="order-img"></div>
                                <div class="order-name">
                                    定制订单<br>
                                    <template v-if="order.customized_status>=4&&order.file_path">
                                        <a class="downloadbtn" :download="order.file_path" :href="order.file_path">
                                            下载设计文件
                                        </a>
                                    </template>
                                </div>
                                <div class="order-price">￥{{order.payed}}</div>
                                <div class="order-num">
                                    <i class="icon iconfont iconchenghao"></i>
                                </div>
                            </div>
                        </div>
                        <div class="order-total-price">￥{{order.order_amount}}</div>
                        <div class="order-state">
                            <div class="order-status">{{getCusOrderStatus(order)}}</div>
                            <div
                                    class="order-detail-link"
                                    tag="a"
                            ><router-link :to="{name:'cusOrderDetail',params:{order_id:order.order_id}}">定制订单详情</router-link>
                            </div>
                        </div>
                        <div class="order-handle">

                            <template v-if="order.customized_status==1">
                <span @click="toPay(order.order_id)">
                  付保证金
                </span>
                            </template>
                            <template v-if="order.customized_status==4">
                            <router-link :to="{name:'cusOrderDetail',params:{order_id:order.order_id}}">
                            确认方案
                            </router-link>
                            </template>
                            <template v-if="order.customized_status==4">
                            <span @click="redes(order.order_id)">
                            重新设计
                            </span>
                            </template>

                            <template v-if="order.customized_status==7">
                <span @click="toPay(order.order_id)">
                  付清尾款
                </span>
                            </template>
                        </div>
                    </div>
                </div>
                <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore"></Pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from "@/components/common/Pagination.vue";
    import {timeToDate} from "@/utils";

    export default {
        name: "MyCurOrder",
        components: {Pagination},
        props: {},
        data() {
            return {
                orderTypes: ["全部"],
                keyword: "",
                statusIndex: 0,
                orderList: [],
                totalPage: 0,
                page: 1,
                limit: 10,
                cus_Btn: "",

            };
        },
        watch: {
            statusIndex() {
                this.initData();
                this.$route.query.type = this.statusIndex;
            }
        },
        computed: {
            orderTime() {
                return time => {
                    return timeToDate(time);
                };
            },

            //获取定制订单状态文字显示
            getCusOrderStatus() {
                return order => {
                    let orderStatusName;
                    switch (order.customized_status) {
                        case 1:
                            orderStatusName = "需求提交，保证金未支付";
                            break;
                        case 2:
                            orderStatusName = "保证金已支付，待分配设计师";
                            break;
                        case 3:
                            orderStatusName = "设计师已分配，方案制作中";
                            break;
                        case 4:
                            orderStatusName = "定制方案已提交，待确认";
                            break;
                        case 5:
                            orderStatusName = "定制方案已提交，待确认";
                            break;
                        case 6:
                            orderStatusName = "首款已支付，制作中";
                            break;
                        case 7:
                            orderStatusName = "制作完成，尾款待支付";
                            break;
                        case 8:
                            orderStatusName = "已付清，待发货";
                            break;
                        case 9:
                            orderStatusName = "已发货，待收货";
                            break;
                        case 10:
                            orderStatusName = "已收货，定制订单完成";
                            break;
                    }
                    return orderStatusName;
                };
            },
        },
        methods: {
            redes(order_id){
                this.$confirm("确定要重新设计", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let data = {
                        order_id: order_id
                    };
                    this.$api.redesOrder(data).then(res => {
                        if (res.status) {
                            this.$msg(res.msg);
                            this.$router.push({name: 'myCurOrder'})
                        }
                    });
                });
            },
            toPay(order_id) {
                this.btnLoading = false
                this.$router.push({
                    name: 'cashier',
                    params: {
                        order_id: order_id,
                    },
                })
            },
            inputChange() {
            },
            initData() {
                this.orderList = [];
                this.getOrderList();
            },
            changeOrderType(index) {
                if (this.statusIndex == index) return;
                this.statusIndex = index;
            },
            //分页加载
            handOrderMore(val) {
                this.page = val;
                this.getOrderList();
            },
            //确认收货
            tackDelivery(order_id) {
                this.$confirm("确定已收到宝贝?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let data = {
                        order_id: order_id
                    };
                    this.$api.confirmOrder(data).then(res => {
                        if (res.status) {
                            this.$msg("确认收货成功!");
                            this.getOrderList();
                        }
                    });
                });
            },
            searchOrder() {
                this.getOrderList();
            },
            getOrderList() {
                let data = {
                    page: this.page,
                    limit: this.limit,
                    status: this.statusIndex,
                    order_type: 9
                };
                if (this.keyword) {
                    data.keyword = this.keyword;
                }
                this.$api.orderList(data).then(res => {
                    if (res.status) {
                        this.totalPage = Math.ceil(
                            Number(res.data.count) / Number(this.limit)
                        );
                        this.orderList = res.data.list;
                    }
                });
            }
        },
        created() {
        },
        mounted() {
            let query = this.$route.query;
            if (query.type) {
                this.statusIndex = query.type
            }
            this.initData();
        }
    };
</script>
<style lang="scss" scoped>
    @import "@/assets/css/mixin.scss";
    @import "@/assets/css/variable.scss";

    .order-item {
        border: 1px solid $border;
        box-sizing: border-box;
        margin-bottom: 20px;

        .order-item-head {
            height: 40px;
            line-height: 40px;
            font-size: 12px;
            color: #757575;
            padding-left: 20px;
            border-bottom: 1px solid $border;

            .time {
                margin-right: 30px;
            }
        }
    }

    .order-box {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;

        &.order-item-main {
            height: 100%;

            .order-info-list {
                border-right: 1px solid $border;
                width: 500px;

                .order-li {
                    display: flex;
                    align-items: center;

                    &:not(:last-of-type) {
                        border-bottom: 1px solid $border;
                    }

                    .order-img {
                        display: block;
                        width: 100px;
                        height: 100px;
                        object-fit: cover;
                        margin-right: 10px;
                    }

                    .order-name {
                        width: 200px;
                        line-height: 20px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }
                }
            }
        }

        &.order-head {
            @include line-height(40px);
            border-top: 1px solid $border;
            border-bottom: 1px solid $border;
            margin: 20px 0;
        }

        .order-info {
            width: 310px;
            text-indent: 20px;
        }

        .order-price {
            width: 100px;
            text-align: center;
        }

        .order-num {
            width: 90px;
            text-align: center;

            .icon {
                font-size: 12px;
            }
        }

        .order-total-price {
            width: 120px;
            text-align: center;
        }

        .order-state {
            width: 150px;
            text-align: center;

            .order-status {
                margin-bottom: 10px;
            }

            .order-detail-link {
                &:hover {
                    color: $theme-color;
                }
            }
        }

        .order-handle {
            width: 150px;
            text-align: center;

            span,
            a {
                padding: 5px 0;
                cursor: pointer;

                &:hover {
                    color: $theme-color;
                }
            }
        }
    }

    .wrapper {
        .top {
            display: flex;
            justify-content: space-between;
            padding-top: 20px;
            align-items: center;

            .tabs {
                .tab {
                    float: left;
                    padding: 0 20px;
                    cursor: pointer;

                    &:hover {
                        color: $theme-color;
                    }

                    &:first-of-type {
                        padding-left: 0;
                    }

                    &:not(:last-of-type) {
                        border-right: 1px solid $border;
                    }

                    &.active {
                        color: $theme-color;
                    }

                    span {
                        color: $theme-color;
                    }
                }
            }

            .search {
                width: 355px;
                height: 40px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(220, 220, 220, 1);
                padding: 10px 0 10px 10px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                align-items: center;
                transition: all 0.2s;
                position: relative;

                .close-btn {
                    position: absolute;
                    right: 50px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 20px;
                    height: 20px;
                }

                &.active {
                    border: 1px solid $theme-color;
                }

                .search-input {
                    display: block;
                    flex: 1;
                    height: 20px;
                }

                .search-icon-wrap {
                    display: inline-block;
                    width: 40px;
                    height: 40px;
                    position: relative;
                    border-left: 1px solid rgba(220, 220, 220, 1);
                    transition: all 0.2s;
                    cursor: pointer;

                    &:hover {
                        color: #fff;
                        background: $theme-color;
                    }

                    &.active {
                        border-color: $theme-color;
                    }

                    .search-icon {
                        position: absolute;
                        width: 20px;
                        height: 20px;
                        top: 10px;
                        left: 10px;

                        .el-icon-search {
                            font-size: 20px;
                        }
                    }
                }
            }
        }
    }

    .no-order {
        height: 100px;
        line-height: 100px;
        text-align: center;
        font-size: 18px;
    }
    .downloadbtn{ background: red; color: #fff; padding: 5px 10px; line-height: 26px; height: 26px;}
</style>